const getters = {
  // common
  startWeekday: state => state.common.start_weekday,

  // pagination
  total: state => state.page.total,
  limit: state => state.page.limit,
  page: state => state.page.page,
  per_page: state => state.page.per_page,
  pageSizes: state => state.page.pageSizes,

  // clinic coupons
  newClinicCoupon: state => state.clinic_coupon.newClinicCoupon,
  isVisibleCsv: state => state.clinic_coupon.isVisibleCsv,
  editClinicCoupon: state => state.clinic_coupon.editClinicCoupon,
  queryClinicCoupon: state => state.clinic_coupon.queryClinicCoupon,
  clinicCouponRules: state => state.clinic_coupon.clinicCouponRules,
  clinicCouponVisible: state => state.clinic_coupon.clinicCouponVisible,
  csvVisible: state => state.clinic_coupon.csvVisible,
  clinicCouponIsEdit: state => state.clinic_coupon.clinicCouponIsEdit,
  clinicCoupons: state => state.clinic_coupon.clinicCoupons,
  clinicCoupon: state => state.clinic_coupon.clinicCoupon,
  therapistsModalVisible: state => state.clinic_coupon.therapistsModalVisible,
  therapistsToSort: state => state.clinic_coupon.therapistsToSort,
  clinicCouponIsEditPosition: state => state.clinic_coupon.clinicCouponIsEditPosition,

  // menu coupons
  newMenuCoupon: state => state.menu_coupon.newMenuCoupon,
  editMenuCoupon: state => state.menu_coupon.editMenuCoupon,
  queryMenuCoupon: state => state.menu_coupon.queryMenuCoupon,
  menuCouponRules: state => state.menu_coupon.menuCouponRules,
  menuCouponVisible: state => state.menu_coupon.menuCouponVisible,
  menuCouponIsEdit: state => state.menu_coupon.menuCouponIsEdit,
  menuCoupons: state => state.menu_coupon.menuCoupons,
  ownerMenuCoupons: state => state.menu_coupon.ownerMenuCoupons,
  clinicMenuCoupons: state => state.menu_coupon.clinicMenuCoupons,
  dropdownMenuCoupons: state => state.menu_coupon.dropdownMenuCoupons,
  clinicNameMenuCoupons: state => state.menu_coupon.clinicNameMenuCoupons,

  // clinic customers
  clinicCustomers: state => state.customer.clinicCustomers,

  //sale_managers
  saleManagerListDay: state => state.sale_manager.list_day,
  saleManagerAmount: state => state.sale_manager.amount,
  data_pie_chart_square_categories: state => state.sale_manager.data_pie_chart_square_categories,
  square_category_colors: state => state.sale_manager.square_category_colors,
  clinicCustomerNotes: state => state.clinic_customer_note.clinicCustomerNotes,

  //therapists
  therapists: state => state.therapist.therapists,
  clinicTherapists: state => state.therapist.clinicTherapists,

  //store branch
  storeBranchs: state => state.parent_report.storeBranchs,
  current_clinic_child: state => state.parent_report.current_clinic_child,
  months_str: state => state.parent_report.months_str,
  treatment_day_of_months: state => state.parent_report.treatment_day_of_months,
  time_prices_chart: state => state.parent_report.time_prices_chart,
  timeprice_colors_chart: state => state.parent_report.timeprice_colors_chart,
  age_customers_chart: state => state.parent_report.age_customers_chart,
  age_colors_chart: state => state.parent_report.age_colors_chart,
  therapists_chart: state => state.parent_report.therapists_chart,
  therapists_average_revanue: state => state.parent_report.therapists_average_revanue,
  scale_gender_chart: state => state.parent_report.scale_gender_chart,
  dataRepeatCharts: state => state.sale_manager_analytic.dataRepeatCharts,
  customerVisted: state => state.sale_manager_analytic.customerVisted,
  averagePrice: state => state.sale_manager_analytic.averagePrice,
  repeatRate: state => state.sale_manager_analytic.repeatRate,
  repeat_chart: state => state.sale_manager_analytic.repeat_chart,
  gender_chart: state => state.sale_manager_analytic.gender_chart,
  timeprice_chart: state => state.sale_manager_analytic.timeprice_chart,
  area_chart: state => state.sale_manager_analytic.area_chart,


  // subscription
  isSubscriptionVisible: state => state.membership_subscription.isSubscriptionVisible,
  newSubscription: state => state.membership_subscription.newSubscription,
  membershipSubscriptionIsEdit: state => state.membership_subscription.membershipSubscriptionIsEdit,
  editMembershipSubscription: state => state.membership_subscription.editMembershipSubscription,
  membershipSubscriptionRules: state => state.membership_subscription.membershipSubscriptionRules,
  membershipSubscriptions: state => state.membership_subscription.membershipSubscriptions,
  queryMembershipSubscription: state => state.membership_subscription.queryMembershipSubscription,
  subscriptionContractStatuses: state => state.membership_subscription.contractStatuses,

  // charge
  isChargeVisible: state => state.membership_charge.isChargeVisible,
  newCharge: state => state.membership_charge.newCharge,
  membershipChargeIsEdit: state => state.membership_charge.membershipChargeIsEdit,
  editMembershipCharge: state => state.membership_charge.editMembershipCharge,
  membershipChargeRules: state => state.membership_charge.membershipChargeRules,
  membershipCharges: state => state.membership_charge.membershipCharges,
  queryMembershipCharge: state => state.membership_charge.queryMembershipCharge,
  clinicCustomerNoteCount: state => state.membership_charge.clinicCustomerNoteCount,

  // charge package
  chargePackages: state => state.charge_package.chargePackages,
  modalChargePackages: state => state.charge_package.modalChargePackages,

  // subscription package
  subscriptionPackages: state => state.subscription_package.subscriptionPackages,
  modalSubscriptionPackages: state => state.subscription_package.modalSubscriptionPackages,

  // validation errors from API
  validationErrors: state => state.error.validationErrors,

  currentClinics: state => state.clinic.currentClinics,
  membershipChargeClinics: state => state.clinic.membershipChargeClinic,
  membershipSubscriptClinic: state => state.clinic.membershipSubscriptClinic,
  currentClinicCustomerNotes: state => state.clinic.currentClinicCustomerNotes,

  //current clinic
  currentClinic: state => state.clinic.currentClinic,
}
export default getters
